var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-lt",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    transform: "scale(.51314 1.0322)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1063,
    height: 708.7,
    fill: "#006a44",
    rx: 0,
    ry: 0,
    transform: "scale(.93865 .69686)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1063,
    height: 236.2,
    y: 475.6,
    fill: "#c1272d",
    rx: 0,
    ry: 0,
    transform: "scale(.93865 .69686)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdb913",
    d: "M0 0h997.8v164.6H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLt);
export default __webpack_public_path__ + "static/media/lt.29e94a11a54dbf9b18b590dd52fa6504.svg";
export { ForwardRef as ReactComponent };